var map = {
	"./TokenAbout.vue": 26345,
	"./TokenChart.vue": 60927,
	"./TokenCommunity.vue": 50277,
	"./TokenInfo.vue": 94006,
	"./TokenMarkets.vue": 89501,
	"./TokenStatistics.vue": 5731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74668;